import { createAction } from '@reduxjs/toolkit';

import { IPostMessage, IPostMessageSendModel } from './types';

const POST_MESSAGE_SEND = 'POST_MESSAGE_SEND';
const POST_MESSAGE_RECEIVE = 'POST_MESSAGE_RECEIVE';

export const postMessageActions = {
  sendMessage: createAction<IPostMessageSendModel>(POST_MESSAGE_SEND),
  messageReceive:
    createAction<MessageEvent<IPostMessage>>(POST_MESSAGE_RECEIVE),
};
